import { Action, Dispatch } from "redux";
import { FieldMapping, IXpathFieldMap } from "../../../models/configuration/xpathFieldMap/IXpathFieldMap";
import { ActionType } from "../../actions";
import PluginService from "../../../services/pluginService";
import { hasXPathConfigChanges } from "../../../utils/xpathConfigChangeDetector";

const saveConfigXPathData = (configId: string, FieldMappings: FieldMapping[], token: string | null) => {
    return async (dispatch: Dispatch<Action>, getState: () => any) => {

        dispatch({
            type: ActionType.SAVE_CONFIG_XPATH_DATA
        });

        const pluginService = new PluginService();
        try {
            if (!FieldMappings) {
                throw new Error("No FieldMappings to save");
            }

            const { persistedData } = getState().xPathData;
            const updatedConfig = {
                Configuration: {
                    FieldMappings: [...FieldMappings]
                }
            };

            const hasChanges = hasXPathConfigChanges(updatedConfig, persistedData);
            if (!hasChanges) {
                dispatch({
                    type: ActionType.SAVE_CONFIG_XPATH_DATA_SUCCESS,
                    payload: updatedConfig
                });
                return false;
            }

            const requestBody = {
                ConfigurationId: configId,
                Configuration: updatedConfig.Configuration
            };

            await pluginService.saveConfig<IXpathFieldMap>(token, "xpath-fieldmap", configId, requestBody);

            dispatch({
                type: ActionType.SAVE_CONFIG_XPATH_DATA_SUCCESS,
                payload: updatedConfig
            });

            return true;

        } catch (error) {
            console.log("saveConfigXPathData --> FAILURE");
            const payloadErrorMessage = error instanceof Error
                ? `Failed to save XPath configuration data: (${error.message})`
                : "Failed to save XPath configuration data: (Unknown error)";
            dispatch({
                type: ActionType.SAVE_CONFIG_XPATH_DATA_FAILURE,
                payload: payloadErrorMessage
            });
            throw new Error(payloadErrorMessage);
        }
    }
}

export default saveConfigXPathData;